/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod_EyebrowInputs */

const es_landing_mod_eyebrow = /** @type {(inputs: Landing_Mod_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres formas de navegar más`)
};

const gl_landing_mod_eyebrow = /** @type {(inputs: Landing_Mod_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres formas de navegar máis`)
};

const en_landing_mod_eyebrow = /** @type {(inputs: Landing_Mod_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three ways to sail more`)
};

/**
* | output |
* | --- |
* | "Three ways to sail more" |
*
* @param {Landing_Mod_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod_eyebrow = /** @type {((inputs?: Landing_Mod_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod_eyebrow(inputs)
	if (locale === "en") return en_landing_mod_eyebrow(inputs)
	return es_landing_mod_eyebrow(inputs)
});